import { Box, Typography } from '@mui/material';
import { Dialog } from 'components/commons';
import ja from 'utils/ja';

interface ConfirmAddUserDialogProps {
  open: boolean;
  onClose: () => void;
  handleConfirm: () => void;
}

const ConfirmAddUserDialog = ({
  open,
  onClose,
  handleConfirm,
}: ConfirmAddUserDialogProps) => {
  return (
    <Dialog
      open={open}
      handleClose={onClose}
      title={ja.user.dialog_add.title}
      handleConfirm={handleConfirm}
    >
      <Box
        sx={{
          width: { xs: '80vw', sm: '638px' },
          padding: '10px',
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: '18px', sm: '22px' },
            fontWeight: '400',
            textAlign: 'center',
          }}
        >
          {ja.user.dialog_add.placeholder}
        </Typography>
      </Box>
    </Dialog>
  );
};
export default ConfirmAddUserDialog;
